import TopHeader from "../../components/TopHeader.tsx";
import "./OrderHistoryLog.css";
import gross from "../../assets/icons/gross.png";
import credit from "../../assets/icons/credit.png";
import leftSidebarArrow from "../../assets/icons/leftSidebarArrow.png";
import service from "../../assets/icons/global.png";
import tip from "../../assets/icons/tips.png";
import mobilePayment from "../../assets/icons/mobile-payment.png";
import bill from "../../assets/icons/bill.png";
import refund from "../../assets/icons/money.png";
import React, { useEffect, useRef, useState } from "react";
import AmountCard from "../components/AmountCard/AmountCard.tsx";
import axios from "axios";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import OrderRow from "./OrderRow.tsx";
import Button from "@mui/material/Button";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TableCell,
  TableRow,
  Typography,
  InputAdornment,
  IconButton,
  TextField,
  CircularProgress,
  useMediaQuery,
} from "@mui/material";
import { Search as SearchIcon, Clear as ClearIcon } from "@mui/icons-material";
import closeIcon from "../../assets/icons/close.png";
import itemImg from "./../../assets/icons/Item.png";
import WithdrawModalContent from "./Component/DialougeContent.jsx";
import BankDetailsSelectionModal from "./Component/BankDetailsSelectionModal.tsx";
import LoadingView from "../components/LoadingView/LoadingView.js";
import TransactionHead from "./Component/TransactionHead.js";
import { useLocation } from "react-router-dom";
import Player from "../../TestSound.js";
import FilterPanel from "./Component/FilterBar/FilterPanel.js";

const OrderHistoryLog = () => {
  const [restaurantId, setRestaurantId] = useState<string>("");
  const [amountData, setAmountData] = useState([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [activeFilters, setActiveFilters] = useState({
    type: "All",
    range: "All",
    custom: { from: "", to: "" },
    withdrawalFees: false,
    unpaidFees: false,
  });
  const [TableData, setTableData] = useState<any[]>([]);
  const [restaurantSelected, setRestaurantSelected] = useState(false);
  const [withdrawTypeSelected, setwithdrawTypeSelected] = useState(false);
  const handleOpen = () => setOpenWithDrawModal(true);
  const handleClose = () => setOpenWithDrawModal(false);
  const api = process.env.REACT_APP_SECRET;
  const [TotalCredit, setTotalCredit] = useState(0);
  const [totalCardValue, setTotalCardValue] = useState({});
  const [totalWithdrawableAmount, setTotalWithdrawableAmount] = useState({});
  const [totalPendingAmount, setTotalPendingAmount] = useState({});
  const [refreshData, setRefreshData] = useState(false);
  const [selectedWithdrawType, setSelectedWithdrawType] = useState(null);
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [calculatedTotal, setCalculatedTotal] = useState({});
  const [selectedRestaurant, setSelectedRestaurant] = useState({});
  const [searchValue, setSearchValue] = useState("");
  const [withdrawEvent, setWithdrawEvent] = useState(false);
  const [activeTab, setActionTab] = useState("Transaction");
  const [restaurants, setRestaurant] = useState([]);
  const [selectedchildRestaurant] = useState(
    JSON.parse(localStorage.getItem("restaurant")),
  );
  const [sidebarCollapse, setSidebarCollapse] = useState(true);
  const location = useLocation();
  const [dataFactory, setDataFactory] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearchValue, setDebouncedSearchValue] = useState(searchValue);
  const [tableDataForCards, setTableDataForCards] = useState<any[]>([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [orderHistoryLogDetailsAmount, setOrderHistoryLogDetailsAmount] =
    useState({});
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);
  const [viewMode, setViewMode] = useState<"amount" | "transacted">("amount");
  const isSmallScreen = useMediaQuery("(max-width:899px)");

  // Handle drag start
  const handleMouseDown = (e: React.MouseEvent) => {
    if (!containerRef.current) return;
    setIsDragging(true);
    setStartX(e.pageX - containerRef.current.offsetLeft);
    setScrollLeft(containerRef.current.scrollLeft);
    // Prevent text selection during drag
    e.preventDefault();
  };

  const handleMouseMove = (e: React.MouseEvent) => {
    if (!isDragging || !containerRef.current) return;
    const x = e.pageX - containerRef.current.offsetLeft;
    const walk = (x - startX) * 2; // Adjust multiplier for sensitivity
    containerRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleMouseUpOrLeave = () => {
    setIsDragging(false);
  };

  // Optional: Improve UX on touch devices
  const handleTouchStart = (e: React.TouchEvent) => {
    if (!containerRef.current) return;
    setIsDragging(true);
    setStartX(e.touches[0].pageX - containerRef.current.offsetLeft);
    setScrollLeft(containerRef.current.scrollLeft);
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    if (!isDragging || !containerRef.current) return;
    const x = e.touches[0].pageX - containerRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    containerRef.current.scrollLeft = scrollLeft - walk;
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchValue(searchValue);
    }, 300); // 300ms delay

    return () => clearTimeout(timer);
  }, [searchValue]);

  const handleRestaurantSelect = (props) => {
    console.log(props);
    var obj = {
      id: props.id,
      name: props.name,
      ulsHLfS: props.isHomeCook,
      FMlYe6C: props.subscriptionPlanId,
    };
    localStorage.setItem("restaurant", JSON.stringify(obj));
    localStorage.setItem("restaurantChanged", "newRestaurantSeelected");

    // Broadcast the change to other tabs
    const broadcastChannel = new BroadcastChannel("storage_change_channel");
    broadcastChannel.postMessage("restaurantChanged");

    window.dispatchEvent(new Event("storage"));
    handleClose();
  };
  const calculateWithdrawnAmount = (trans) => {
    const withdrawTransactions =
      trans?.filter((item) => item.type === "Withdraw") || [];
    return withdrawTransactions.reduce(
      (sum, item) => sum + (parseFloat(item.transactionAmount) || 0),
      0,
    );
  };

  const getTotalRefundedAmount = (rowTrans) => {
    const refunded = rowTrans?.filter((item) => item.type === "Refund") || [];
    return refunded.reduce(
      (sum, item) => sum + (parseFloat(item.transactionAmount) || 0),
      0,
    );
  };

  const CheckWithdrawableAmount = (rowData) => {
    // For "Transaction" rows: compute available balance
    if (rowData.transactionStatus === "Transaction") {
      const totalOrderPrice =
        (parseFloat(rowData.totalPrice) || 0) -
        (parseFloat(rowData.totalTransactionFees) || 0);

      const withdrawable = calculateWithdrawnAmount(rowData?.transactions);
      const refundedAmount = getTotalRefundedAmount(rowData?.transactions);

      return totalOrderPrice + refundedAmount + withdrawable;
    }

    // For "Withdraw" rows: compute net balance = available + withdrawn
    if (rowData.transactionStatus === "Withdraw") {
      const base = parseFloat(rowData.totalWithdrawableAmount) || 0;
      const withdrawn = parseFloat(rowData.totalWithdrawnAmount) || 0;
      return base + withdrawn; // e.g., 30 + (-38.78) = -8.78
    }

    // Others: not relevant for unpaid
    return NaN;
  };

  const loadDataForRestaurant = async () => {
    const token = localStorage.getItem("gotasteadmintoken");
    var decodedData = {};

    if (token != null) {
      try {
        decodedData = jwt_decode(token);

        var obj = {
          id: decodedData.UserId,
          title: decodedData.UserName,
        };
      } catch (error) {}
    }

    const restaurant = JSON.parse(localStorage.getItem("parentrestaurant"));

    await axios
      .get(
        api +
          "/api/Restaurant/getrestaurantdetailsbyidfortable/" +
          "2e528a48-2121-48bd-97d4-b6ec8865bff2" +
          "/" +
          restaurant.id,
      )
      .then((response) => {
        var list = [];
        response.data.map((dt, i) => {
          const isHomeCook = dt.isHomeCookToggle || false;
          let fallbackPlanId = isHomeCook ? 0 : -1;
          var obj = {
            id: dt.id,
            name: dt.name,
            address: dt.addressLine1,
            PhoneNumber: dt.phoneNumber,
            Email: dt.emailAddress,
            subscriptionPlanId: dt.subscriptionPlanId || fallbackPlanId,
            isHomeCook: isHomeCook,
          };
          list.push(obj);
        });

        setRestaurant(list);
      });
  };

  useEffect(() => {
    const token = localStorage.getItem("gotasteadmintoken");

    const parentrestaurant = JSON.parse(
      localStorage.getItem("parentrestaurant"),
    );

    var decodedData = {};

    if (token != null) {
      try {
        decodedData = jwt_decode(token);
        console.log(decodedData);
        setTokenData(decodedData);
      } catch (error) {}
    }

    loadDataForRestaurant();
  }, []);

  const handleClickOpen = () => {
    setOpen(true);
  };
  interface Transaction {
    transactionId: string;
    dateTime: string;
    totalAmount: number;
    transactionAmount: number;
    remainingBalance: number;
  }

  useEffect(() => {
    const restaurant = localStorage.getItem("parentrestaurant");
    if (restaurant) {
      setRestaurantId(JSON.parse(restaurant).id);
    }
  }, []);

  // useEffect(() => {
  //   (async () => {
  //     try {
  //       setLoading(true);
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_SECRET}/api/Order/GetOrderHistoryByRestaurant?restaurentId=${restaurantId}`
  //       );
  //       console.log("restaurant id local: ", response.data);
  //       setAmountData(response.data);
  //     } catch (error) {
  //       console.log(error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   })();
  // }, [restaurantId]);

  const rows = [
    {
      orderId: "01",
      transaction: "Withdraw",
      dateTime: "08-02-25",
      totalAmount: 100,
      totalRefunded: 0,
      totalServiceCharge: 10,
      totalTips: 20,
      totalCredit: 0,
      totalPlatformFees: 0.5,
      totalProcessingFees: 0.6,
      totalCaptureFees: 0.05,
      totalAuthenticationFees: 0.07,
      totalTrnsactionFees: 1.22,
      // withdrawed: -10,
      totalWithdrawableAmount: 38.78,
      foodItems: [
        {
          withdrawType: "Full",
          transactionId: "577445774",
          dateTime: "08-02-25",
          totalWithdrawnAmount: -38.78,
          remainingWithdrableBalance: 0,
          matchedRefundedOrder: "03", // order number from which this money was taken.
          matchedRefundedAmount: 30.0,
          paidToBankAccount: 8.78,
        },
      ],
    },
    {
      orderId: "01",
      transaction: "Refund",
      dateTime: "07-02-25",
      totalAmount: 100,
      totalRefunded: -50,
      totalServiceCharge: 10,
      totalTips: 20,
      totalCredit: 0,
      totalPlatformFees: 0.5,
      totalProcessingFees: 0.6,
      totalCaptureFees: 0.05,
      totalAuthenticationFees: 0.07,
      totalTrnsactionFees: 1.22,
      // withdrawed: 0,
      totalWithdrawableAmount: 48.78,
      foodItems: [
        {
          foodItemName: "Salmon Burger",
          transactionId: "68899686",
          dateTime: "07-02-25",
          refunded: -50,
          matchOrder: "2, 3",
          matchAmount: 12.0,
        },
      ],
    },
    {
      orderId: "01",
      transaction: "Transaction",
      dateTime: "06-02-25",
      totalAmount: 100,
      totalRefunded: 0,
      totalServiceCharge: 10,
      totalTips: 20,
      totalCredit: 0,
      totalPlatformFees: 0.5,
      totalProcessingFees: 0.6,
      totalCaptureFees: 0.05,
      totalAuthenticationFees: 0.07,
      totalTrnsactionFees: 1.22,
      // withdrawed: 0,
      totalWithdrawableAmount: 98.78,
      foodItems: [
        {
          foodItemName: "Salmon burger",
          totalServiceCharge: 10,
          totalTips: 20,
          totalCredit: 0,
          foodItemBasePrice: 20,
          totalAmount: 98.78,
          addons: [
            {
              addonName: "addon Name",
              addOnVatAmount: 1,
              addOnSdAmount: 8,
              addOnQuantity: 2,
              addOnBasePrice: 4,
              addOnTotalPrice: 11,
              options: [
                {
                  optionName: "option name",
                  optionVatAmount: 1.1,
                  optionSdAmount: 1.23,
                  optionQuantity: 4,
                  optionBasePrice: 2,
                  optionTotalPrice: 44,
                  subOptions: [
                    {
                      subOptionName: "sub option name",
                      subOptionVatAmount: 4,
                      subOptionSdAmount: 1,
                      subOptionQuantity: 3,
                      subOptionBasePrice: 4,
                      subOptoinTotalPrice: 22,
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          foodItemName: "Cheese Burger",
          totalServiceCharge: 10,
          totalTips: 20,
          totalCredit: 0,
          foodItemBasePrice: 20,
          totalAmount: 98.78,
          addons: [],
        },
      ],
    },
  ];

  const transactions: Transaction[] = [
    {
      transactionId: "577445774",
      dateTime: "09-02-25",
      totalAmount: 38.78,
      transactionAmount: -38.78,
      remainingBalance: 0,
    },
    {
      transactionId: "43833428",
      dateTime: "08-02-25",
      totalAmount: 48.78,
      transactionAmount: -10,
      remainingBalance: 38.78,
    },
    {
      transactionId: "68899686",
      dateTime: "07-02-25",
      totalAmount: 98.78,
      transactionAmount: -50,
      remainingBalance: 48.78,
    },
    {
      transactionId: "53893483",
      dateTime: "06-02-25",
      totalAmount: 98.78,
      transactionAmount: 0,
      remainingBalance: 98.78,
    },
  ];

  const [openWithDrawModal, setOpenWithDrawModal] = useState(false);

  // const AmountCardClicked = () => {
  //     setOpenWithDrawModal(!openWithDrawModal);
  // }

  const AmountCardClicked = (title: string) => {
    if (
      title === "Total Available Amount" ||
      title === "Total Service Ch." ||
      title === "Total Tips"
    ) {
      setOpenWithDrawModal(true);
    }
  };

  const loadOrderHistoryLogData = async () => {
    setLoading(true);
    let restaurant = localStorage.getItem("restaurant");
    let restaurantObj = restaurant ? JSON.parse(restaurant) : null;
    console.log("restaurantObj", restaurantObj);
    if (restaurantObj?.id) {
      await axios
        .get(
          `${process.env.REACT_APP_SECRET}/api/OrderHistoryLog?restaurantId=${restaurantObj.id}`,
        )
        .then((response) => {
          setDataFactory(response.data);
          const normalizeRow = (row: any) => {
            const d = new Date(
              row.orderPlacementDateTime ||
                row.transactionDateTime ||
                row.createdAt ||
                row.orderCompletionDateTime,
            );
            const dateStr = isNaN(d.getTime())
              ? ""
              : `${d.getDate()} ${String(d.getDate()).padStart(2, "0")} ${d.getMonth() + 1} ${String(d.getMonth() + 1).padStart(2, "0")} ${
                  [
                    "jan",
                    "feb",
                    "mar",
                    "apr",
                    "may",
                    "jun",
                    "jul",
                    "aug",
                    "sep",
                    "oct",
                    "nov",
                    "dec",
                  ][d.getMonth()]
                } ${d.getFullYear()}`;

            return {
              ...row,
              _searchKey: [
                row.id,
                row.orderId,
                row.transactionStatus,
                row.transaction,
                row.type,
                row.status,
                row.orderStatus,
                row.currentStatus,
                row.paymentStatus,
                row.totalPrice,
                row.totalRefundedAmount,
                row.totalServiceCharge,
                row.totalTips,
                row.totalCredit,
                row.subTotal,
                dateStr,
              ]
                .filter(Boolean)
                .map(String)
                .join(" ")
                .toLowerCase(),
            };
          };

          // Then:
          const normalizedData = response.data.map(normalizeRow);
          setDataFactory(normalizedData);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error fetching order history:", error);
        });
    }
  };

  useEffect(() => {
    setTimeout(() => {
      loadOrderHistoryLogData();
    }, 200);
  }, [refreshData, withdrawEvent, location.key, location]);

  const GetTotalCreditByRestaurantId = async (restaurantId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SECRET}/api/OrderHistoryLog/GetTotalCreditByRestaurantId/${restaurantId}`,
      );
      if (response !== null) {
        setTotalCredit(response.data);
      }
    } catch (error) {
      console.log("Error fetching total credit:", error);
    }
  };

  useEffect(() => {
    const localSelectedRestaurant = localStorage.getItem("restaurant");

    if (localSelectedRestaurant) {
      const parsedRestaurant = JSON.parse(localSelectedRestaurant);
      const getTotalCredit = async () => {
        await GetTotalCreditByRestaurantId(parsedRestaurant.id);
      };

      getTotalCredit();
    }
  }, []);

  const GetTotalCalculatedAmount = async () => {
    try {
      const restaurant = JSON.parse(localStorage.getItem("restaurant"));
      await axios
        .get(
          `${process.env.REACT_APP_SECRET}/api/OrderHistoryLog/GetTotalAmount?restaurantId=${restaurant?.id}`,
        )
        .then((response) => {
          setTotalCardValue(response?.data?.totalAmount);
          setTotalPendingAmount(response?.data?.totalPendingAmount);
          setTotalWithdrawableAmount(response?.data?.totalWithdrawableAmount);
        });
    } catch (exception) {
      console.log(exception);
    }
  };

  useEffect(() => {
    if (!tableDataForCards?.length) {
      setTotalCardValue({});
      setTotalPendingAmount({});
      setTotalWithdrawableAmount({});
      setOrderHistoryLogDetailsAmount({});
      return;
    }

    // Helpers
    const calculateWithdrawnAmount = (t) =>
      (t?.filter((x) => x.type === "Withdraw") || []).reduce(
        (s, x) => s + (parseFloat(x.transactionAmount) || 0),
        0,
      );
    const getTotalRefundedAmount = (t) =>
      (t?.filter((x) => x.type === "Refund") || []).reduce(
        (s, x) => s - (parseFloat(x.transactionAmount) || 0),
        0,
      );
    const computeWithdrawableAmountForRow = (row) => {
      if (row.transactionStatus !== "Transaction") return 0;
      const base =
        (parseFloat(row.totalPrice) || 0) -
        (parseFloat(row.totalTransactionFees) || 0);
      return (
        base -
        calculateWithdrawnAmount(row.transactions) -
        getTotalRefundedAmount(row.transactions)
      );
    };

    // 🔑 Index Transaction rows by orderId
    const txnById = {};
    tableDataForCards
      .filter((r) => r.transactionStatus === "Transaction")
      .forEach((r) => {
        const id = String(r.orderId);
        if (id) txnById[id] = r;
      });

    // Initialize
    const totals = {
      amount: {
        totalAmount: 0,
        pendingAmount: 0,
        withdrawableAmount: 0,
        totalCredit: 0,
        pendingCredit: 0,
        withdrawableCredit: 0,
        totalServiceCharge: 0,
        pendingServiceCharge: 0,
        withdrawableServiceCharge: 0,
        totalTips: 0,
        pendingTips: 0,
        withdrawableTips: 0,
      },
      transacted: {
        totalAmount: 0,
        pendingAmount: 0,
        withdrawableAmount: 0,
        totalCredit: 0,
        pendingCredit: 0,
        withdrawableCredit: 0,
        totalServiceCharge: 0,
        pendingServiceCharge: 0,
        withdrawableServiceCharge: 0,
        totalTips: 0,
        pendingTips: 0,
        withdrawableTips: 0,
      },
    };

    const modalTotals = {
      totalVat: 0,
      totalSd: 0,
      totalWithdrawn: 0,
      totalRefund: 0,
    };

    tableDataForCards
      .filter((r) => r.transactionStatus === "Transaction")
      .forEach((r) => {
        const hasWithdraw = (r.transactions || []).some(
          (t) => t.type === "Withdraw",
        );
        const effStatus = hasWithdraw
          ? "withdrawn"
          : (r.orderStatus || "").toLowerCase();

        const withdrawable = computeWithdrawableAmountForRow(r);
        const transactedAmt =
          (parseFloat(r.totalPrice) || 0) -
          (parseFloat(r.totalTransactionFees) || 0);
        const credit = parseFloat(r.totalCredit) || 0;
        const service = parseFloat(r.totalServiceCharge) || 0;
        const tips = parseFloat(r.totalTips) || 0;

        // ➕ "amount" view
        if (effStatus === "pending") {
          totals.amount.pendingAmount += withdrawable;
          totals.amount.pendingCredit += credit;
          totals.amount.pendingServiceCharge += service;
          totals.amount.pendingTips += tips;
        } else if (effStatus === "ready") {
          totals.amount.withdrawableAmount += withdrawable;
          totals.amount.withdrawableCredit += credit;
          totals.amount.withdrawableServiceCharge += service;
          totals.amount.withdrawableTips += tips;
        }

        // ➕ "transacted" view
        if (effStatus === "pending") {
          totals.transacted.pendingAmount += transactedAmt;
          totals.transacted.pendingCredit += credit;
          totals.transacted.pendingServiceCharge += service;
          totals.transacted.pendingTips += tips;
        } else if (effStatus === "ready") {
          totals.transacted.withdrawableAmount += transactedAmt;
          totals.transacted.withdrawableCredit += credit;
          totals.transacted.withdrawableServiceCharge += service;
          totals.transacted.withdrawableTips += tips;
        }
      });

    tableDataForCards
      .filter((r) => r.transactionStatus === "Refund")
      .forEach((r) => {
        const matchedId = String(r.matchedRefundedOrder);
        const origTxn = txnById[matchedId];
        if (!origTxn) return;

        const hasWithdraw = (origTxn.transactions || []).some(
          (t) => t.type === "Withdraw",
        );
        const effStatus = hasWithdraw
          ? "withdrawn"
          : (origTxn.orderStatus || "").toLowerCase();

        const creditRefund = parseFloat(r.totalCredit) || 0;
        const serviceRefund = parseFloat(r.totalServiceCharge) || 0;
        const tipsRefund = parseFloat(r.totalTips) || 0;

        if (effStatus === "pending") {
          totals.amount.pendingCredit -= creditRefund;
          totals.amount.pendingServiceCharge -= serviceRefund;
          totals.amount.pendingTips -= tipsRefund;
        } else if (effStatus === "ready") {
          totals.amount.withdrawableCredit -= creditRefund;
          totals.amount.withdrawableServiceCharge -= serviceRefund;
          totals.amount.withdrawableTips -= tipsRefund;
        }
      });

    // ➕ Finalize sums
    ["totalAmount", "totalCredit", "totalServiceCharge", "totalTips"].forEach(
      (k) => {
        totals.amount[k] =
          totals.amount[`pending${k.slice(5)}`] +
          totals.amount[`withdrawable${k.slice(5)}`];
        totals.transacted[k] =
          totals.transacted[`pending${k.slice(5)}`] +
          totals.transacted[`withdrawable${k.slice(5)}`];
      },
    );

    // ➕ Modal (unchanged)
    tableDataForCards.forEach((r) => {
      if (r.transactionStatus === "Transaction") {
        modalTotals.totalVat += parseFloat(r.totalVat) || 0;
        modalTotals.totalSd += parseFloat(r.totalSd) || 0;
      } else if (r.transactionStatus === "Withdraw") {
        modalTotals.totalWithdrawn += Math.abs(parseFloat(r.totalPrice) || 0);
      } else if (r.transactionStatus === "Refund") {
        modalTotals.totalRefund += Math.abs(
          parseFloat(r.totalRefundedAmount) || 0,
        );
      }
    });

    // ✅ Set states
    setTotalCardValue({
      totalAmount: totals.amount.totalAmount,
      totalTransacted: totals.transacted.totalAmount,
      totalCredit: totals.amount.totalCredit,
      totalTransactedCredit: totals.transacted.totalCredit,
      totalServiceCharge: totals.amount.totalServiceCharge,
      totalTransactedServiceCharge: totals.transacted.totalServiceCharge,
      totalTips: totals.amount.totalTips,
      totalTransactedTips: totals.transacted.totalTips,
    });

    setTotalPendingAmount({
      totalAmount: totals.amount.pendingAmount,
      totalTransacted: totals.transacted.pendingAmount,
      totalCredit: totals.amount.pendingCredit,
      totalTransactedCredit: totals.transacted.pendingCredit,
      totalServiceCharge: totals.amount.pendingServiceCharge,
      totalTransactedServiceCharge: totals.transacted.pendingServiceCharge,
      totalTips: totals.amount.pendingTips,
      totalTransactedTips: totals.transacted.pendingTips,
    });

    setTotalWithdrawableAmount({
      totalAmount: totals.amount.withdrawableAmount,
      totalTransacted: totals.transacted.withdrawableAmount,
      totalCredit: totals.amount.withdrawableCredit,
      totalTransactedCredit: totals.transacted.withdrawableCredit,
      totalServiceCharge: totals.amount.withdrawableServiceCharge,
      totalTransactedServiceCharge: totals.transacted.withdrawableServiceCharge,
      totalTips: totals.amount.withdrawableTips,
      totalTransactedTips: totals.transacted.withdrawableTips,
    });

    setOrderHistoryLogDetailsAmount(modalTotals);
  }, [tableDataForCards]);

  const SelectedWithdrawTypes = (data) => {
    setSelectedWithdrawType(data);
  };

  const GetSelectedOrders = (data) => {
    setSelectedOrders(data);
  };

  const getCalculatedTotal = (data) => {
    setCalculatedTotal(data);
  };

  const getSelectedRestaurant = (data) => {
    setSelectedRestaurant(data);
  };

  const handleSearch = (query: string) => {
    setSearchValue(query);
    if (query === "") {
      setIsSearchFocused(false);
    }
  };

  useEffect(() => {
    if (!dataFactory || dataFactory.length === 0) {
      setTableData([]);
      setTableDataForCards([]);
      return;
    }

    setSearchLoading(true);

    const timer = setTimeout(() => {
      try {
        const { type, range, custom, withdrawalFees, unpaidFees } =
          activeFilters;

        const q = (debouncedSearchValue || "").trim().toLowerCase();
        const hasSearch = q.length > 0;

        let startDate: Date | null = null;
        let endDate: Date | null = null;

        if (range && range !== "All") {
          const now = new Date();

          switch (range) {
            case "Today":
              startDate = new Date(
                now.getFullYear(),
                now.getMonth(),
                now.getDate(),
                0,
                0,
                0,
              );
              endDate = new Date(
                now.getFullYear(),
                now.getMonth(),
                now.getDate(),
                23,
                59,
                59,
                999,
              );
              break;

            case "This Week": {
              const day = now.getDay();
              const diff = now.getDate() - day;
              startDate = new Date(now.setDate(diff));
              startDate.setHours(0, 0, 0, 0);

              endDate = new Date(startDate);
              endDate.setDate(startDate.getDate() + 6);
              endDate.setHours(23, 59, 59, 999);
              break;
            }

            case "This Month":
              startDate = new Date(now.getFullYear(), now.getMonth(), 1);
              endDate = new Date(
                now.getFullYear(),
                now.getMonth() + 1,
                0,
                23,
                59,
                59,
                999,
              );
              break;

            case "This Year":
              startDate = new Date(now.getFullYear(), 0, 1);
              endDate = new Date(now.getFullYear(), 11, 31, 23, 59, 59, 999);
              break;

            case "Custom":
              if (custom?.from && custom?.to) {
                startDate = new Date(custom.from);
                endDate = new Date(custom.to);
                endDate.setHours(23, 59, 59, 999);
              }
              break;
          }
        }

        const monthNames = [
          "jan",
          "feb",
          "mar",
          "apr",
          "may",
          "jun",
          "jul",
          "aug",
          "sep",
          "oct",
          "nov",
          "dec",
        ];

        const safeLower = (x: any) =>
          x == null ? "" : String(x).toLowerCase();
        const getDate = (row: any) =>
          row.orderPlacementDateTime ||
          row.transactionDateTime ||
          row.createdAt ||
          row.orderCompletionDateTime;

        const buildSearchDateString = (dateString: string): string => {
          if (!dateString) return "";
          const d = new Date(dateString);
          if (isNaN(d.getTime())) return "";

          const day = d.getDate();
          const month = d.getMonth() + 1;
          const monthName = monthNames[d.getMonth()];
          const year = d.getFullYear();

          return (
            `${day} ${String(day).padStart(2, "0")} ${month} ${String(
              month,
            ).padStart(2, "0")} ${monthName} ${year} ` +
            `${monthName} ${day}, ${year} ${day} ${monthName} ${monthName} ${day} ` +
            `${day}/${month}/${year} ${year}-${month}-${day}`
          ).toLowerCase();
        };

        const table: any[] = [];
        const cards: any[] = [];

        for (const row of dataFactory) {
          const rowDateValue = getDate(row);
          const rowDate = rowDateValue ? new Date(rowDateValue) : null;

          if (startDate && endDate) {
            if (!rowDate || rowDate < startDate || rowDate > endDate) continue;
          }

          let passFeeFilter = true;

          if (withdrawalFees) {
            passFeeFilter = (parseFloat(row.totalWithdrawFees) || 0) > 0;
          } else if (unpaidFees) {
            const withdrawable = CheckWithdrawableAmount(row);
            passFeeFilter = !isNaN(withdrawable) && withdrawable < 0;
          }

          const typeValue = safeLower(
            row.transactionStatus || row.transaction || row.type || "",
          );
          const passType =
            type === "All" || !type || typeValue === type.toLowerCase();

          const passSearch = !hasSearch || row._searchKey.includes(q);

          if (passSearch) {
            cards.push(row);
            if (passType && passFeeFilter) {
              table.push(row);
            }
          }
        }
        const getStamp = (row: any) =>
          new Date(
            row.transactionDateTime ||
              row.orderPlacementDateTime ||
              row.createdAt,
          ).getTime();

        table.sort((a, b) => getStamp(b) - getStamp(a));
        cards.sort((a, b) => getStamp(b) - getStamp(a));

        setTableData(table);
        setTableDataForCards(cards);
      } finally {
        setSearchLoading(false);
      }
    }, 20);

    return () => clearTimeout(timer);
  }, [dataFactory, debouncedSearchValue, activeFilters]);

  const withdrawOnClick = () => {
    setSelectedOrders([]);
    setWithdrawEvent(!withdrawEvent);
  };

  const switchTabContent = (usedIN) => {
    setActionTab(usedIN);
  };

  useEffect(() => {
    document.title = activeTab + " | Order History Log";
  }, [activeTab]);

  // Withdraw Processing
  const [needToAdjust, setNeedToAdjust] = useState([]);
  const NeedToAdjust = (data) => {
    setNeedToAdjust(data);
  };

  console.log(
    "RefundDetails",
    TableData.filter((item) => item.transactionStatus === "Refund"),
  );

  const handleFilterChange = (filter) => {
    setActiveFilters((prev) => ({
      type: filter.type,
      range: filter.range,
      custom: filter.custom,
      withdrawalFees: filter.withdrawalFees ?? false,
      unpaidFees: filter.unpaidFees ?? false,
    }));
  };

  useEffect(() => {
    GetTotalCalculatedAmount();
  }, []);

  return (
    <div>
      <TopHeader />
      <div className="sidebarOpen">
        {!sidebarCollapse && (
          <div className="d-flex gap-2 align-items-center">
            <img
              src={leftSidebarArrow}
              style={{ width: "20px", height: "50px", rotate: "180deg" }}
              onClick={() => setSidebarCollapse(!sidebarCollapse)}
            />
          </div>
        )}
      </div>

      <Grid container className="d-flex flex-row ">
        {/* Sidebar */}
        <Grid
          item
          xs={2}
          style={{
            display: !sidebarCollapse ? "none" : "block",
            position: "relative",
          }}
        >
          {/* ---Restaurant Selection--- */}
          <div
            className="d-flex order_history_log__side-bar-container"
            style={{ width: "100%" }}
          >
            <div style={{ width: "100%" }}>
              <Box
                sx={{
                  maxWidth: "95%",
                  width: "100%",
                  marginTop: "1rem",
                  marginBottom: "1rem",
                  marginLeft: ".5rem",
                }}
              >
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    {selectedchildRestaurant.name}
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    style={{ marginLeft: "0px" }}
                    // value={age}
                    label="Restaurant Name"
                    // onChange={handleChange}
                  >
                    {restaurants.map((dt, i) => {
                      return (
                        <MenuItem
                          style={{ background: "none" }}
                          onClick={() => {
                            handleRestaurantSelect(dt);
                          }}
                          selected={selectedchildRestaurant.name == dt.name}
                        >
                          {dt.name}
                        </MenuItem>
                      );
                    })}

                    {/* <MenuItem value={20}>Pot Kettle Black Manchester</MenuItem> */}
                  </Select>
                </FormControl>
              </Box>
            </div>
          </div>

          {/* --Transaction--Invoice--Refund--left arrow--- */}
          <div className="p-2 d-flex flex-column gap-2 listContainer">
            {/* -- Transaction Tab -- */}
            <div
              className={`order_history_log__menuItemContainer ${
                activeTab === "Transaction" ? "active" : ""
              }`}
              onClick={() => switchTabContent("Transaction")}
            >
              <img className="sidebarIcon" src={mobilePayment} />
              <Typography>Transaction Log</Typography>
            </div>

            {/* -- InVoice Tab -- */}
            {/* <div
              className={`order_history_log__menuItemContainer ${activeTab === "Invoice" ? 'active' : ''}`}
              onClick={() => switchTabContent("Invoice")}
            >
              <img className="sidebarIcon" src={bill} />
              <Typography>Invoice Log</Typography>
            </div> */}

            {/* -- Refund Tab -- */}
            {/* <div
              className={`order_history_log__menuItemContainer ${activeTab === "Refund" ? 'active' : ''}`}
              onClick={() => switchTabContent("Refund")}
            >
              <img className="sidebarIcon" src={refund} />
              <Typography>Refund Log</Typography>
            </div> */}

            {/* --Left Arrow-- */}
            <div className="sidebarToolbar">
              {sidebarCollapse && (
                <img
                  src={leftSidebarArrow}
                  style={{ cursor: "pointer", height: "50px", width: "20px" }}
                  onClick={() => setSidebarCollapse(!sidebarCollapse)}
                />
              )}
            </div>
          </div>
        </Grid>

        {/* Right Side Content */}
        <Grid item xs={!sidebarCollapse ? 12 : 10}>
          {/* Amount View Selector — only in Transaction tab */}
          {activeTab === "Transaction" && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                px: 2,
                mb: 1,
                mt: 2,
              }}
            >
              <FormControl size="small" sx={{ minWidth: 180 }}>
                <InputLabel>Amount View</InputLabel>
                <Select
                  value={viewMode}
                  label="Amount View"
                  onChange={(e) =>
                    setViewMode(e.target.value as "amount" | "transacted")
                  }
                >
                  <MenuItem value="amount">Total Available Amount</MenuItem>
                  <MenuItem value="transacted">
                    Total Transacted Amount
                  </MenuItem>
                </Select>
              </FormControl>
            </Box>
          )}
          {/* Cards */}
          <div
            className="amount-card-container"
            style={{ justifyContent: !sidebarCollapse ? "center" : "" }}
          >
            {/* 1️⃣ Total Available Amount */}
            <div onClick={() => AmountCardClicked("Total Available Amount")}>
              <AmountCard
                orderHistoryLogDetailsAmount={orderHistoryLogDetailsAmount}
                title={
                  viewMode === "transacted"
                    ? "Total Transacted Amount"
                    : "Total Available Amount"
                }
                amount={
                  "£ " +
                  (viewMode === "amount"
                    ? (totalCardValue.totalAmount ?? 0).toFixed(2)
                    : (totalCardValue.totalTransacted ?? 0).toFixed(2))
                }
                pendingAmount={
                  "£ " +
                  (viewMode === "amount"
                    ? (totalPendingAmount.totalAmount ?? 0).toFixed(2)
                    : (totalPendingAmount.totalTransacted ?? 0).toFixed(2))
                }
                withdrawableAmount={
                  "£ " +
                  (viewMode === "amount"
                    ? (totalWithdrawableAmount.totalAmount ?? 0).toFixed(2)
                    : (totalWithdrawableAmount.totalTransacted ?? 0).toFixed(2))
                }
                icon={gross}
                colorCode={"#FF8F00"}
                usedIn="Amount"
              />
            </div>

            {/* 2️⃣ Total Credit */}
            <AmountCard
              orderHistoryLogDetailsAmount={orderHistoryLogDetailsAmount}
              title="Total Credit"
              usedIn="Credit"
              amount={
                "£ " +
                (viewMode === "amount"
                  ? (totalCardValue.totalCredit ?? 0).toFixed(2)
                  : (totalCardValue.totalTransactedCredit ?? 0).toFixed(2))
              }
              pendingAmount={
                "£ " +
                (viewMode === "amount"
                  ? (totalPendingAmount.totalCredit ?? 0).toFixed(2)
                  : (totalPendingAmount.totalTransactedCredit ?? 0).toFixed(2))
              }
              withdrawableAmount={
                "£ " +
                (viewMode === "amount"
                  ? (totalWithdrawableAmount.totalCredit ?? 0).toFixed(2)
                  : (
                      totalWithdrawableAmount.totalTransactedCredit ?? 0
                    ).toFixed(2))
              }
              icon={credit}
              colorCode={"#42A5F5"}
            />

            {/* 3️⃣ Total Service Ch. */}
            <div onClick={() => AmountCardClicked("Total Service Ch.")}>
              <AmountCard
                orderHistoryLogDetailsAmount={orderHistoryLogDetailsAmount}
                title="Total Service Ch."
                usedIn="Service Ch."
                amount={
                  "£ " +
                  (viewMode === "amount"
                    ? (totalCardValue.totalServiceCharge ?? 0).toFixed(2)
                    : (
                        totalCardValue.totalTransactedServiceCharge ?? 0
                      ).toFixed(2))
                }
                pendingAmount={
                  "£ " +
                  (viewMode === "amount"
                    ? (totalPendingAmount.totalServiceCharge ?? 0).toFixed(2)
                    : (
                        totalPendingAmount.totalTransactedServiceCharge ?? 0
                      ).toFixed(2))
                }
                withdrawableAmount={
                  "£ " +
                  (viewMode === "amount"
                    ? (totalWithdrawableAmount.totalServiceCharge ?? 0).toFixed(
                        2,
                      )
                    : (
                        totalWithdrawableAmount.totalTransactedServiceCharge ??
                        0
                      ).toFixed(2))
                }
                icon={service}
                colorCode={"#26A69A"}
              />
            </div>

            {/* 4️⃣ Total Tips */}
            <div onClick={() => AmountCardClicked("Total Tips")}>
              <AmountCard
                orderHistoryLogDetailsAmount={orderHistoryLogDetailsAmount}
                title="Total Tips"
                usedIn="Tips"
                amount={
                  "£ " +
                  (viewMode === "amount"
                    ? (totalCardValue.totalTips ?? 0).toFixed(2)
                    : (totalCardValue.totalTransactedTips ?? 0).toFixed(2))
                }
                pendingAmount={
                  "£ " +
                  (viewMode === "amount"
                    ? (totalPendingAmount.totalTips ?? 0).toFixed(2)
                    : (totalPendingAmount.totalTransactedTips ?? 0).toFixed(2))
                }
                withdrawableAmount={
                  "£ " +
                  (viewMode === "amount"
                    ? (totalWithdrawableAmount.totalTips ?? 0).toFixed(2)
                    : (
                        totalWithdrawableAmount.totalTransactedTips ?? 0
                      ).toFixed(2))
                }
                icon={tip}
                colorCode={"rgb(61, 130, 16)"}
              />
            </div>
          </div>
          {/* Filter Panel + Search Bar — aligned side-by-side */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
              px: 2,
              py: 1,
            }}
          >
            {/* Scrollable container */}
            <Box
              ref={containerRef}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                overflowX: { xs: "auto", sm: "visible" },
                overflowY: "hidden",
                "&::-webkit-scrollbar": { display: "none" },
                msOverflowStyle: "none",
                scrollbarWidth: "none",

                /* 🔥 FIX: Always keep everything in one row */
                flexWrap: "nowrap",

                /* 🔥 FIX: Ensure no item shifts vertically */
                minHeight: "40px",

                WebkitOverflowScrolling: "touch",
                cursor: { xs: isDragging ? "grabbing" : "grab", sm: "default" },
              }}
              onMouseDown={handleMouseDown}
              onMouseMove={handleMouseMove}
              onMouseUp={handleMouseUpOrLeave}
              onMouseLeave={handleMouseUpOrLeave}
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleMouseUpOrLeave}
            >
              {/* Search */}
              {!searchValue && !isSearchFocused ? (
                <IconButton
                  size="small"
                  onClick={() => setIsSearchFocused(true)}
                  sx={{
                    p: 0.5,
                    flexShrink: 0, // 🚀 Important: Never shrink the search icon
                  }}
                >
                  <SearchIcon fontSize="small" />
                </IconButton>
              ) : (
                <TextField
                  size="small"
                  variant="outlined"
                  value={searchValue}
                  onChange={(e) => handleSearch(e.target.value)}
                  autoFocus
                  onFocus={() => setIsSearchFocused(true)}
                  onBlur={(e) => {
                    if (!e.target.value) setIsSearchFocused(false);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Escape") {
                      handleSearch("");
                      setIsSearchFocused(false);
                    }
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon fontSize="small" />
                      </InputAdornment>
                    ),
                    endAdornment: searchValue && (
                      <InputAdornment position="end">
                        <IconButton
                          size="small"
                          onClick={() => handleSearch("")}
                          edge="end"
                        >
                          <ClearIcon fontSize="small" />
                        </IconButton>
                      </InputAdornment>
                    ),
                    sx: { borderRadius: "20px", height: "32px" },
                  }}
                  sx={{
                    width: { xs: "180px", sm: "220px" },
                    minWidth: { xs: "150px", sm: "unset" },
                    flexShrink: 0, // 🚀 Important: do not allow shrinking
                  }}
                />
              )}

              {/* FilterPanel */}
              <Box sx={{ flexShrink: 0 }}>
                <FilterPanel onFilterChange={handleFilterChange} />
              </Box>
            </Box>
          </Box>

          {/* ---Transaction tab content--- */}
          <div
            style={{
              display: activeTab === "Transaction" ? "block" : "none",
            }}
          >
            {loading ? (
              <LoadingView open={true} close={() => setLoading(false)} />
            ) : searchLoading ? (
              <LoadingView open={true} close={() => {}} />
            ) : isSmallScreen ? (
              // Small device behavior
              <TableContainer
                component={Paper}
                className="order-history-table"
                sx={{
                  maxHeight: "400px",
                  overflowX: "auto",
                  overflowY: "auto",
                }}
              >
                <Table
                  aria-label="sticky table"
                  sx={{
                    tableLayout: "fixed",
                    "& th, & td": {
                      position: "static",
                      left: "unset",
                      zIndex: "unset",
                    },
                  }}
                  className="order-table"
                  stickyHeader
                >
                  <TransactionHead />
                  <TableBody>
                    {TableData.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={10} align="center">
                          No transactions found.
                        </TableCell>
                      </TableRow>
                    ) : (
                      TableData.sort(
                        (a, b) =>
                          new Date(b.transactionDateTime) -
                          new Date(a.transactionDateTime),
                      ).map((row, i) => (
                        <OrderRow
                          key={i}
                          row={row}
                          transactions={transactions}
                          TotalData={TableData}
                          SetRefreshData={setRefreshData}
                          RefreshData={refreshData}
                        />
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              // Desktop behavior
              <TableContainer
                component={Paper}
                className="order-history-table"
                sx={{ maxHeight: "100vh" }}
              >
                <Table
                  aria-label="sticky table"
                  sx={{ tableLayout: "fixed" }}
                  className="order-table"
                  stickyHeader
                >
                  <TransactionHead />
                  <TableBody>
                    {TableData.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={10} align="center">
                          No transactions found.
                        </TableCell>
                      </TableRow>
                    ) : (
                      TableData.sort(
                        (a, b) =>
                          new Date(b.transactionDateTime) -
                          new Date(a.transactionDateTime),
                      ).map((row, i) => (
                        <OrderRow
                          key={i}
                          row={row}
                          transactions={transactions}
                          TotalData={TableData}
                          SetRefreshData={setRefreshData}
                          RefreshData={refreshData}
                        />
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </div>

          {/* ---Invoice tab content--- */}
          <div style={{ display: activeTab === "Invoice" ? "block" : "none" }}>
            <h4 className="LogsTabContentHeading">Invoice Log</h4>

            {/* Data Table */}
            {loading ? (
              <LoadingView
                open={true}
                close={() => {
                  setLoading(false);
                }}
              />
            ) : (
              <TableContainer component={Paper} className="order-history-table">
                <Table aria-label="collapsible table" className="order-table">
                  <TransactionHead />
                  <TableBody>
                    {TableData.sort(
                      (a, b) =>
                        new Date(b.transactionDateTime) -
                        new Date(a.transactionDateTime),
                    ).map((row) => (
                      <OrderRow
                        // key={row.orderId}
                        key={row.id}
                        row={row}
                        transactions={transactions}
                        TotalData={TableData}
                        SetRefreshData={setRefreshData}
                        RefreshData={refreshData}
                      />
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </div>

          {/* -- Refund tab content -- */}
          <div style={{ display: activeTab === "Refund" ? "block" : "none" }}>
            {/* Data Table */}
            {loading ? (
              <LoadingView
                open={true}
                close={() => {
                  setLoading(false);
                }}
              />
            ) : (
              <TableContainer component={Paper} className="order-history-table">
                <Table aria-label="collapsible table" className="order-table">
                  <TransactionHead />
                  <TableBody>
                    {TableData.sort(
                      (a, b) =>
                        new Date(b.transactionDateTime) -
                        new Date(a.transactionDateTime),
                    )
                      .filter((trans) => trans.transactionStatus === "Refund")
                      .map((row) => (
                        <OrderRow
                          // key={row.orderId}
                          key={row.id}
                          row={row}
                          transactions={transactions}
                          TotalData={TableData}
                          SetRefreshData={setRefreshData}
                          RefreshData={refreshData}
                        />
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </div>
        </Grid>
      </Grid>

      {/* WithDraw Modal */}
      <React.Fragment>
        <Dialog
          fullWidth={true}
          maxWidth={"xl"}
          open={openWithDrawModal}
          onClose={handleClose}
        >
          {/* Header */}
          <Grid
            container
            className="d-flex space-between align-items-center"
            style={{ backgroundColor: "rgba(86, 89, 91, 0.69)" }}
          >
            {/* Logo & header - dialouge header */}
            <Grid item xs={6}>
              <DialogTitle>
                <div className="d-flex" style={{ gap: "8px" }}>
                  {/* Logo */}
                  <div>
                    <img src={itemImg} style={{ width: "1.8rem" }} alt="" />
                  </div>
                  {/* Header */}
                  <span
                    style={{
                      // color: "#2a7fd4"
                      color: "white",
                    }}
                  >
                    Widthdraw Modal
                  </span>
                </div>
              </DialogTitle>
            </Grid>
            {/* Close button - header */}
            <Grid item xs={6}>
              <DialogActions>
                <Button onClick={() => setOpenWithDrawModal(false)}>
                  <img
                    src={closeIcon}
                    alt="Close"
                    style={{ width: "1.2rem" }}
                  />
                </Button>
              </DialogActions>
            </Grid>
          </Grid>

          <DialogContent style={{ backgroundColor: "#f3f0f3" }}>
            <WithdrawModalContent
              setRestaurantSelected={setRestaurantSelected}
              getSelectedWithdrawTypes={SelectedWithdrawTypes}
              getSelectedOrders={GetSelectedOrders}
              GetCalculatedTotal={getCalculatedTotal}
              GetSelectedRestaurant={getSelectedRestaurant}
              withdrawOnClick={withdrawEvent}
              needToAdjust={NeedToAdjust}
            />
          </DialogContent>

          {/* Footer */}
          <DialogActions style={{ marginRight: "10px" }}>
            <Button
              onClick={handleClickOpen}
              color="primary"
              variant="contained"
              disabled={
                selectedOrders?.length === 0 || selectedWithdrawType === null
              }
            >
              Next
            </Button>
            <Button onClick={handleClose} color="secondary">
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <BankDetailsSelectionModal
          open={open}
          setOpen={setOpen}
          selectedOrders={selectedOrders}
          calculatedTotal={calculatedTotal}
          selectedRestaurant={selectedRestaurant}
          selectedWithdrawTypes={selectedWithdrawType}
          withdrawSuccessfull={() => {
            withdrawOnClick();
            setOpenWithDrawModal(false);
            GetTotalCalculatedAmount();
            setOpen(false);
          }}
          NeedToAdjustForPayload={needToAdjust}
        />
      </React.Fragment>
    </div>
  );
};

export default OrderHistoryLog;
